import { setConsentCookie } from 'utils/cookieConsent';

export function setConsent(consent) {
    return async dispatch => {
        if (consent) {
            _paq.push(['setCookieConsentGiven']);  // eslint-disable-line no-undef
        }

        setConsentCookie(consent);

        dispatch({ type: 'SET_CONSENT', payload: { consent } });
    };
}
